/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { PageType, PageDataParams, ModuleCompletionData } from 'its-pages';
import React, { ReactElement } from 'react';
import { ModuleCompletion } from '../containers/module-completion';
import { PageContent } from './page-content';

export class ModuleCompletionContent extends PageContent {
  public get component(): ReactElement {
    return (
      <ModuleCompletion
        moduleCompletionContent={this}
        key={this.pageData.seed}
      />
    );
  }

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public constructor(params: PageDataParams) {
    super(new ModuleCompletionData(params));
  }
}
